import SEO from "@/components/site/SEO";
import FeatureGrid from "@/components/sections/FeatureGrid";
import HowItWorks from "@/components/sections/HowItWorks";
import CTA from "@/components/sections/CTA";
import { Smartphone, ShieldCheck, Globe2 } from "lucide-react";

export default function Features() {
  return (
    <div data-testid="page-features">
      <SEO title="Features" description="Every feature SECQRE ships — masked calls, scan analytics, document vault, emergency contacts, and a fleet-ready dashboard." path="/features" />

      <section className="pt-32 md:pt-40 pb-12">
        <div className="container-secqre">
          <span className="overline">— Features</span>
          <h1 className="mt-4 font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tight" data-testid="features-page-title">
            Built like infrastructure.<br />Used like a sticker.
          </h1>
          <p className="mt-6 text-lg md:text-xl text-[#475569] max-w-2xl">
            We're obsessed with two things: keeping your number invisible, and making the experience
            so simple your grandma will install the app first try.
          </p>
        </div>
      </section>

      <section className="pb-12">
        <div className="container-secqre grid md:grid-cols-3 gap-5">
          <SpecCard icon={ShieldCheck} title="Privacy by default" body="Your number lives only on our encrypted servers. Calls relay through a one-time bridge." />
          <SpecCard icon={Smartphone} title="No app for scanners" body="Any phone camera works. No download. No friction. The QR opens a clean contact page." />
          <SpecCard icon={Globe2} title="Made for the US" body="Local numbers, masked SMS via American carriers, WhatsApp & iMessage compatible." />
        </div>
      </section>

      <FeatureGrid />
      <HowItWorks />
      <CTA />
    </div>
  );
}

function SpecCard({ icon: Icon, title, body }) {
  return (
    <div className="rounded-2xl border border-[#E2E8F0] bg-white p-7" data-testid={`spec-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="w-11 h-11 rounded-lg bg-[#F8F9FA] inline-flex items-center justify-center mb-5">
        <Icon className="w-5 h-5 text-[#0F172A]" />
      </div>
      <h3 className="font-heading font-bold text-xl">{title}</h3>
      <p className="mt-2 text-[#475569]">{body}</p>
    </div>
  );
}
